export default "__VITE_ASSET__$lW4W5gc__"